<template>
    <div>
        <h3><slot></slot></h3>
        <hr>
    </div>
</template>

<script>
export default {
    name: "SubSubHeading"
}
</script>

<style scoped>
    h3{
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 1.2;
        margin: 0px;
        margin-top: 1.5rem;
        margin-bottom: .5rem;
    }
    hr{
        border-top:none;
    }
</style>